import useDataLayer from '@/hooks/useDataLayer/useDataLayer';
import React, { useState } from 'react';
import AccordionItem from '../AccordionItem/AccordionItem';
import RichText from '../RichText/RichText';
import styles from './Accordion.module.scss';
import { AccordionListItemComponentProps, AccordionProps } from './types';

export const AccordionListItem = ({
  description,
  headline,
  isActive,
  onClick,
  color = 'default',
  hasFaqSchema = false,
}: AccordionListItemComponentProps) => {
  return (
    <AccordionItem
      onClick={onClick}
      headline={headline}
      isActive={isActive}
      color={color}
      hasFaqSchema={hasFaqSchema}
    >
      <RichText className={styles.description}>{description}</RichText>
    </AccordionItem>
  );
};

const Accordion = ({ items, color = 'default', hasFaqSchema = false }: AccordionProps) => {
  const [activeItem, setActiveItem] = useState<null | number>(null);
  const { pushDataLayerEvent } = useDataLayer();

  const handleOnClick = (idx: number, headline: string) => {
    if (idx !== activeItem) {
      setActiveItem(idx);
      pushDataLayerEvent({
        event: 'customClick3',
        customClickText: headline,
      });
    } else {
      setActiveItem(null);
    }
  };

  const itemList = items.map((item, idx: number) => {
    return (
      <AccordionListItem
        isActive={idx === activeItem}
        headline={item.headline}
        description={item.description}
        key={idx}
        onClick={() => handleOnClick(idx, item.headline)}
        color={color}
        hasFaqSchema={hasFaqSchema}
      />
    );
  });

  const faqSchemaProps = hasFaqSchema
    ? {
        itemScope: true,
        itemType: 'https://schema.org/FAQPage',
      }
    : {};

  return (
    <div {...faqSchemaProps}>
      {itemList}
    </div>
  );
};

export const AccordionMagnolia = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div>{children}</div>;
};

export default Accordion;
